module.exports = {
  "APP_NAME": "Thirsty Camel",
  "BUNDLE_ID": "NOT_APPLICABLE",
  "BUNDLE_VERSION": 1,
  "MARKETING_VERSION": "3.4.9",
  "WHITE_LABEL_ID": "thirstycamel",
  "BASE_TENANT": "TC",
  "BASE_URL": "https://mw.lmg-bw.au",
  "TILL_GATEWAY": "https://gateway.tillpayments.com/js/integrated/payment.1.3.min.js",
  "HOST_DOMAIN": "wa.thirstycamel.com.au",
  "DEFAULT_STORE": "C000141706",
  "DEFAULT_STORE_STATE": "WA",
  "SUPPORT_EMAIL": "online@wa.thirstycamel.com.au",
  "GIFT_CARD_STORE": "thirstycamelgiftstore",
  "GIFT_CARDS_PROMOTION_ID": "ThirstyCamel-gift-card",
  "FF_IS_GIFT_CARDS_ENABLED": true,
  "FF_LOYALTY_ENABLED": true,
  "ONESIGNAL_APP_ID": "938f2081-3f05-4265-92bf-d1d4258eab54"
}
